
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ProgramsPage from '../pages/programs/page';
import CurriculumPage from '../pages/programs/curriculum/page';
import AdmissionsPage from '../pages/admissions/page';
import EnrollPage from '../pages/admissions/enroll/page';
import TuitionPage from '../pages/admissions/tuition/page';
import FormsPage from '../pages/admissions/forms/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/programs',
    element: <ProgramsPage />,
  },
  {
    path: '/programs/curriculum',
    element: <CurriculumPage />,
  },
  {
    path: '/admissions',
    element: <AdmissionsPage />,
  },
  {
    path: '/admissions/enroll',
    element: <EnrollPage />,
  },
  {
    path: '/admissions/tuition',
    element: <TuitionPage />,
  },
  {
    path: '/admissions/forms',
    element: <FormsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
